import { ThemeOptions } from '@material-ui/core';

/**
 * This is a theme override on top of our main theme.
 * Use it as `<MuiProvider themeOverride={blackTheme}>`.
 * Not sure where Ale is headed with this new design and how consistently we plan to apply it...
 */
export const blackTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#000000',
    },
  },
  typography: {
    h1: {
      fontSize: 36,
      fontWeight: 600,
      letterSpacing: -0.84,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        padding: 15,
        borderRadius: 50,
      },
    },
    MuiInputLabel: {
      root: {
        textTransform: 'initial',
        // fix mui v5 label animation
        '&.v5-MuiInputLabel-formControl.v5-MuiInputLabel-shrink': {
          transform: 'translate(0, 1.5px) scale(0.75)',
        },
      },
      formControl: {
        transform: `translate(0, 23px) scale(1)`,
      },
    },
  },
};
